export const TransferMAAI = {
    convert_tip: "Transfer TIP Coin to MAAI BY KTC",
    convert_success : "Coin transfer successful",
    please_enter: "Please enter the number of Coins to transfer",
    Continue: "Continue",
    Cancel: "Cancel",
    your_tip_coin: "Your TIP Coin",
    back_home: "Back to Home",

    confirm_convert: "Confirm",
    tip_coin: "TIP Coin",
    MAAI_point: "MAAI Point",
    conversion_undone: "Once the transfer is made, it cannot be canceled",
    Member: "Member",

    convert_error: "Transfer Error",
    please_contact_callcanter: "Please contact our call center",
    Close: "Close",

    something_wrong : "Something Went Wrong",
    sorry: "Sorry, we are unable to process your request.<br>Please try again",
    tranfer_to_maai: "Transfer to MAAI BY KTC",
    receive_from_maai: "Receive coin from MAAI BY KTC",
    transfer_earn: "Receive coin from ",
    transfer_coins: "Transfer to ",
}
